import Colors from "../../useclass/colors";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { useSnackbar } from 'notistack';
import useIsMountedRef from "../../utils/mountedRef";
import Simulateur_Donations from "./simulateur.donations/simulateur.Donations";
import Simulateur_Successions from "./simulateur.successions/simulateur.Successions";
import { useSelector } from "react-redux";
import LinkDMTGPDF from "../../utils/simulateurs/link.DMTG.PDF";
import './modal.css';
import close from "../../assets/images/close.png"
import "../../assets/fonts/Roboto/Roboto-Regular.ttf";
import { makeStyles } from "@material-ui/core/styles";
import * as React from "react";
import ReactGA from "react-ga4";


function DmtgMain(props) {
    const { enqueueSnackbar } = useSnackbar();
    const isMountedRef = useIsMountedRef();
    const currentSimulateurId = props?.callSinceSimu ? props.simulateur.id : props.match.params.simulateur;
    const [show, setShow] = useState(false)
    const [parentSimulateur, setParentSimulateur] = useState({})
    const [createPDF, setCreatePDF] = useState(false)
    const [simulateurResponse, setSimulateurResponse] = useState({})
    const [readyPDF, setReadyPDF] = useState(false)
    let data = useSelector((state) => state.dmtgResults);
    const [arrayContent, setArrayContent] = useState([])
    const beforeCalculateDMTGRef = useRef(null)
    const registerBeforeCalculate = useCallback((fn) => {
        beforeCalculateDMTGRef.current = fn || null;
    }, []);

    useEffect(() => {
        const items = { ...localStorage };
        Object.keys(items).map((key, value) => {
            if (isNumeric(key.toString())) {
                localStorage.removeItem(key)
            }
        })
        localStorage.removeItem("outputAffinage");
        localStorage.removeItem("usageId");
        localStorage.removeItem('nameSimuDMTG')
        localStorage.removeItem("conjointSurvivantDMTG")
    }, [isMountedRef]);

    const showHideClassName = show ? "modal display-block" : "modal display-none";

    function setid() {
        let checkTest;
        if (props?.callSinceSimu)
            checkTest = props.simulateur.id
        else
            checkTest = currentSimulateurId

        return checkTest
    }

    const getSimulateur = useCallback(() => {

        axios.defaults.withCredentials = true;
        setParentSimulateur({ id: Number(currentSimulateurId), name: "" });

        const myPromise = new Promise(async (resolve, reject) => {
            if (props?.callSinceSimu) {
                let checkTest = await setid();
                resolve(checkTest)
            } else resolve(currentSimulateurId)

        });


        myPromise
            .then((response) => {
                var config = {
                    method: 'get',
                    url: `${API_BASE_URL}/simulateurs/${response}`,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(localStorage.getItem("user"))?.jwt,
                    },
                };
                axios(config)
                    .then((response) => {
                        if (response.status === 200 && response.data != null) {
                            if (isMountedRef.current) {
                                setParentSimulateur(response.data)
                            }
                        } else {
                            enqueueSnackbar('Une erreur est survenue', {
                                variant: 'error'
                            });
                            //    window.location = "/app"
                        }
                    })
                    .catch((error) => {
                        // 1. Gestion spécifique du 401 / Autre utilisateur connecté
                        if (error.response?.status === 401 && error.response.data != null) {
                            if (error.response.data.error == "Other_user_connected" ) {
                                localStorage.removeItem("user")
                                localStorage.setItem("other_user_connected", "other_user_connected")
                                window.location.href = "/login"
                                return;
                            } else {
                                localStorage.removeItem("user");
                                window.location.href = "/login";
                                enqueueSnackbar('Session expirée', {variant: 'error'});
                                return;
                            }
                        }

                        // 2. Gestion générique de toutes les autres erreurs
                        enqueueSnackbar('Une erreur est survenue', {
                            variant: 'error'
                        });
                    });
            })
    }, [currentSimulateurId, enqueueSnackbar, isMountedRef, props?.callSinceSimu])

    const styles = {
        container: {
            width: "100%",
            color: Colors.textBlack,
            fontFamily: "Regular"
        },
        container1: {
            display:"flex",
            flexDirection:"row",
            width: "100%",
            color: Colors.textBlack,
            minHeight: "75vh",
            backgroundColor: Colors.ultraLightGrey,
            fontFamily: "Regular"

        },
        ctnButton: {
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
            paddingBottom: 30,
            paddingTop: 30,

        },
        ctnButtonValide: {
            marginLeft: "auto",
            marginRight: "auto",
            paddingBottom: 30,
            paddingTop: 0,
            textAlign: "center",
            width: "30%"
        },
        buttonCalculate: {
            display: "block",
            margin: "auto",
            width: "30%",
            height: 35,
            borderRadius: 5,
            border: "none",
            backgroundColor: "#49708C",
            color: Colors.white,
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "2px 2px 1px rgba(0,0,0, 0.2)",
            hover: "#6399BF",
        },
        ctnTable: {
            width: "97%",
            marginTop: 10,
            marginBottom: 30,
            backgroundColor: Colors.white,
            //  boxShadow: "2px 2px 1px rgba(0,0,0, 0.2)",
            //width: "95%",
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 4,
            minWidth: 400,
        },

        ctnTableData: {
            width: "100%",
            textAlign: "left",
            display: "flex",
            flexDirection: "row",
            minHeight: 400,

        },
        table: {
            width: "75%",
        },

        tableBody: {
            width: "100%",
            display: "flex",
            borderCollapse: "collapse",
            margin: "auto",
            flexDirection: "row",
            flexWrap: "wrap",
            alignContent: "center",
            justifyContent: "space-evenly",
        },

        tr: {
            width: "auto",
            borderCollapse: "collapse",
            borderRadius: 5,
            textAlign: "center"
        },

        td1: {
            width: "70%",
            borderCollapse: "collapse",
            padding: "5px 5px 5px 10px",
            textAlign: "left",
            verticalAlign: "middle",
        },

        td2: {
            width: "200px",
            borderCollapse: "collapse",
            padding: "5px 10px 5px 5px",
            height: 40,
            textAlign: "right",
            verticalAlign: "middle",
        },


    };


    useEffect(() => {
        getSimulateur();
    }, [getSimulateur]);

    useEffect(() => {
        localStorage.setItem('nameSimuDMTG', parentSimulateur.name)
    }, [parentSimulateur]);

    let handleData;

    function dmtgTreatment(dependance, i, j) {
        return new Promise(resolve => {
            try {
                const { abattement_reconstitue, ...calculationInputs } = dependance.inputs || {};
                var config = {
                    method: 'post', url: `${API_BASE_URL}/calculateur`, headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(localStorage.getItem("user"))?.jwt
                    }, data: { ...dependance, inputs: calculationInputs }
                };
                axios(config)
                    .then((response) => {
                        if (response.status === 200 && response.data != null) {
                            handleData.data[i].donataires[j] = {
                                ...handleData.data[i].donataires[j],
                                output: response.data,
                            } //simulateurObject.data.dependances[i].results
                            resolve();
                        } else {
                            enqueueSnackbar('Le simulateur ' + parentSimulateur.name + " est mal renseigné", {
                                variant: 'error'
                            });
                            Promise.reject("fail dependence")
                        }
                    })
                    .catch((error) => {
                        enqueueSnackbar('Tous les champs n\'ont pas été correctement renseignés.', {
                            variant: 'error'
                        });
                        Promise.reject("fail dependence")
                    
                        if (error.response?.status === 401 && error.response.data != null) {
                            if (error.response.data.error == "Other_user_connected" ) {
                                localStorage.removeItem("user")
                                localStorage.setItem("other_user_connected", "other_user_connected")
                                window.location.href = "/login"
                            }
                        }
                    });
            } catch (e) {
                return null
            }
        })
    }
    async function calculateConjointSurvivant(payload) {
        const config = {
            method: 'post',
            url: `${API_BASE_URL}/calculateur`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': JSON.parse(localStorage.getItem("user"))?.jwt
            },
            data: payload
        };

        const response = await axios(config);
        return response.data;
    }

    function buildDataWithConjointSurvivant(baseData, conjointSurvivantResult) {
        if (conjointSurvivantResult?.nouvelle_masse_a_partager === undefined || conjointSurvivantResult?.nouvelle_masse_a_partager === null || !Array.isArray(baseData?.data)) {
            return baseData;
        }

        const clonedData = JSON.parse(JSON.stringify(baseData));
        const nouvelleMasse = parseInt(conjointSurvivantResult.nouvelle_masse_a_partager || 0);

        clonedData.data = clonedData.data.map((donateurBlock) => {
            if (!Array.isArray(donateurBlock?.donataires) || donateurBlock.donataires.length === 0) {
                return donateurBlock;
            }

            const nombreHeritiers = donateurBlock.donataires.length;

            return {
                ...donateurBlock,
                donataires: donateurBlock.donataires.map((donataire) => {
                    const montantRapportable = parseInt(donataire?.inputs?.montant_rapportable || 0);
                    const montantRevenantHeritier = Math.ceil(nouvelleMasse / nombreHeritiers);

                    return {
                        ...donataire,
                        inputs: {
                            ...donataire.inputs,
                            total_succession: nouvelleMasse,
                            montantRevenantHeritier,
                            montant_succession: montantRevenantHeritier - montantRapportable,
                        }
                    }
                })
            }
        });
        return clonedData;
    }

    async function check(data) {
        if (Array.isArray(data.data) && data.data.length > 0) {
            localStorage.setItem("dmtgInputs", JSON.stringify(data));
            handleData = JSON.parse(localStorage.getItem("dmtgInputs"));
            if (data?.data?.length > 0 || data?.data !== undefined) {
                for (let i = 0; i < handleData.data.length; i++) {
                    for (let j = 0; j < handleData.data[i].donataires?.length; j++) {
                        let handle = handleData.data[i].donataires[j] //simulateurObject.data.dependances[i].inputs
                        await dmtgTreatment(handle, i, j)
                    }
                }
                //MISE EN FORME DE L'OBJET RESULTAT
                //console.log("handleData" + JSON.stringify(handleData))
                setSimulateurResponse(handleData)
                var handleVar = handleData.data
                var allDonataireData = []
                for (let i = 0; i < handleData.data[0].donataires.length; i++) {
                    allDonataireData[i] = []
                    //console.log("allDonataireData" + allDonataireData[i])
                    //console.log(JSON.stringify(handleData.data[i]))
                    for (let j = 0; j < handleData.data.length; j++) {
                        var allData = []
                        if (handleData.data[j].donataires[i].output.DMTG !== undefined) {
                            allData.push({
                                key: "DMTG",
                                name: "Droits DMTG à payer",
                                value: parseInt(handleData.data[j].donataires[i].output.DMTG).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                            })
                        } else {
                            allData.push({
                                key: "DMTG",
                                name: "Droits DMTG à payer",
                                value: "0€"
                            })
                        }

                        if (handleData.data[j].donataires[i].output.droits_regles_total !== undefined && handleData.data[j].donataires[i].output.droits_regles_total !== 0) {
                            allData.push({
                                key: "droits_regles_total",
                                name: "Total des droits déjà réglés sur les donations antérieures",
                                value: parseInt(handleData.data[j].donataires[i].output.droits_regles_total).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                            })
                        }
                        const currentDonataire = handleData.data[j].donataires[i];
                        const currentOutput = currentDonataire?.output || {};
                        const representants = Array.isArray(currentDonataire?.representants) ? currentDonataire.representants : [];
                        const nombreRepresentants = parseInt(currentDonataire?.inputs?.nombre_representants || representants.length || 0);
                        const montantRepresentant = nombreRepresentants > 0
                            ? Math.round(parseInt(currentDonataire?.inputs?.montant_succession || 0) / nombreRepresentants)
                            : 0;
                        const montantRevenantHeritierValue =
                            parseInt(currentDonataire?.inputs?.montantRevenantHeritier || 0) > 0
                                ? parseInt(currentDonataire.inputs.montantRevenantHeritier)
                                : Math.round(
                                    parseInt(currentDonataire?.inputs?.total_succession || currentOutput.total_succession || 0) /
                                    Math.max(handleData.data[j].donataires.length, 1)
                                );

                        if (parseInt(currentDonataire?.inputs?.handicap || 0) === 1) {
                            allData.push({
                                key: "handicap",
                                name: "Situation de handicap",
                                value: "Oui"
                            })
                        }
                        if (currentDonataire?.inputs?.montantRevenantHeritier !== undefined) {
                            allData.push({
                                key: "montant_revenant_heritier",
                                name: "Montant lui revenant",
                                value: formatEuro(montantRevenantHeritierValue)
                            })
                        }
                        if (currentDonataire?.inputs?.montant_rapportable !== undefined) {
                            allData.push({
                                key: "montant_rapportable",
                                name: "Montant des donations, reçues par l'héritier, rapportables à la succession",
                                value: formatEuro(currentDonataire?.inputs?.montant_rapportable || 0)
                            })
                        }
                        if (currentDonataire?.inputs?.montant_succession !== undefined) {
                            allData.push({
                                key: "montant_succession",
                                name: "Montant taxable revenant à l'héritier",
                                value: formatEuro(currentDonataire?.inputs?.montant_succession || 0)
                            })
                        }
                        if (Number(currentDonataire?.inputs?.abattement_reconstitue || 0) > 0) {
                            allData.push({
                                key: "abattement_reconstitue",
                                name: "Abattement reconstitué dans le rappel fiscal",
                                value: formatEuro(currentDonataire.inputs.abattement_reconstitue)
                            });
                        }

                        if (handleData.data[j].donataires[i].output.base_dmtg !== undefined) {
                            allData.push({
                                key: "base_dmtg",
                                name: "Base Taxable",
                                value: parseInt(handleData.data[j].donataires[i].output.base_dmtg).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                            })
                        }
                        if (handleData.data[j].donataires[i].output.montant_article757b !== undefined && handleData.data[j].donataires[i].output.montant_article757b !== 0) {
                            allData.push({
                                key: "montant_article757b",
                                name: "Montant Article 757 B",
                                value: formatPositive(handleData.data[j].donataires[i].output.montant_article757b)
                            })
                        }
                        if (handleData.data[j].donataires[i].output.reliquat_total !== undefined && handleData.data[j].donataires[i].output.reliquat_total !== 0) {
                            allData.push({
                                key: "reliquat_total",
                                name: "Déduction faite du reliquat total des parts de tranches non utilisées lors des donations antérieures à 2012 :",
                                value: parseInt(handleData.data[j].donataires[i].output.reliquat_total).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                            })
                        }
                        if (handleData.data[j].donataires[i].output.immo !== undefined && handleData.data[j].donataires[i].output.immo !== 0) {
                            allData.push({
                                key: "immo",
                                name: "Montant Immobilier",
                                value: parseInt(handleData.data[j].donataires[i].output.immo).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                            })
                        }
                        if (handleData.data[j].donataires[i].output.especes !== undefined && handleData.data[j].donataires[i].output.especes !== 0) {
                            allData.push({
                                key: "especes",
                                name: "Montant Espèces",
                                value: parseInt(handleData.data[j].donataires[i].output.especes).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                            })
                        }
                        if (handleData.data[j].donataires[i].output.abattement_total !== undefined) {
                            allData.push({
                                key: "abattement_total",
                                name: "Abattement appliqué",
                                value: parseInt(handleData.data[j].donataires[i].output.abattement_total).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                            })
                        }
                        if (handleData.data[j].donataires[i].output.abattement_restant !== undefined) {
                            allData.push({
                                key: "abattement_restant",
                                name: "Abattement légal restant",
                                value: parseInt(handleData.data[j].donataires[i].output.abattement_restant).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                            })
                        }
                        if (handleData.data[j].donataires[i].output.tranche_initiale !== undefined && hasPositiveValue(handleData.data[j].donataires[i].output.tranche_initiale)) {
                            allData.push({
                                key: "tranche_initiale",
                                name: "Taux tranche initiale",
                                value: parseInt(handleData.data[j].donataires[i].output.tranche_initiale * 100).toLocaleString("en-EN") + " %",
                                rawValue: handleData.data[j].donataires[i].output.tranche_initiale
                            })
                        }
                        if (handleData.data[j].donataires[i].output.reliquat_tranche_donation !== undefined && handleData.data[j].donataires[i].output.reliquat_tranche_donation < 599999999) {
                            allData.push({
                                key: "reliquat_tranche_donation",
                                name: "Reliquat de tranche initiale non utilisé lors des donations antérieures",
                                value: parseInt(handleData.data[j].donataires[i].output.reliquat_tranche_donation).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                            });
                        }
                        if (handleData.data[j].donataires[i].output.tranche_finale !== undefined && hasPositiveValue(handleData.data[j].donataires[i].output.tranche_finale)) {
                            allData.push({
                                key: "tranche_finale",
                                name: "Taux tranche finale",
                                value: parseInt(handleData.data[j].donataires[i].output.tranche_finale * 100).toLocaleString("en-EN") + " %",
                                rawValue: handleData.data[j].donataires[i].output.tranche_finale
                            })
                        }
                        if (handleData.data[j].donataires[i].output.total_succession !== undefined) {
                            allData.push({
                                key: "total_succession",
                                name: "Masse à partager avec l'ensemble des héritiers",
                                value: parseInt(handleData.data[j].donataires[i].output.total_succession).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                            })
                        }
                        if (parseInt(currentDonataire?.inputs?.est_represente || 0) === 1 && representants.length > 0) {
                            representants.forEach((representant, index) => {
                                const representantIndex = representant.representant_index || index + 1;
                                const representantPrefix = `representant_${representantIndex}`;
                                allData.push({
                                    key: `${representantPrefix}_title`,
                                    name: `Représentant ${representantIndex}`,
                                    value: ""
                                });
                                if (parseInt(representant.handicap || 0) === 1) {
                                    allData.push({
                                        key: `${representantPrefix}_handicap`,
                                        name: "Situation de handicap",
                                        value: "Oui"
                                    });
                                }
                                allData.push({
                                    key: `${representantPrefix}_montant_correspondant`,
                                    name: "Montant lui revenant",
                                    value: parseInt(montantRepresentant || 0).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                                });
                                if (parseInt(representant.beneficiaire_assurance_vie || 0) === 1) {
                                    allData.push({
                                        key: `${representantPrefix}_beneficiaire_assurance_vie`,
                                        name: "Bénéficiaire assurance-vie",
                                        value: "Oui"
                                    });
                                    allData.push({
                                        key: `${representantPrefix}_montant_article757b`,
                                        name: "Montant Article 757 B",
                                        value: formatPositive(representant.montant_taxable_article757b || 0)
                                    });
                                    // À réactiver si la ligne doit de nouveau être affichée dans le cadre du représentant.
                                    // allData.push({
                                    //     key: `${representantPrefix}_part_abattement_legal_restant`,
                                    //     name: "Part restante de l'abattement légal du représentant",
                                    //     value: formatEuro(representant.part_abattement_legal_restant || 0)
                                    // });
                                }
                                if (currentOutput[`${representantPrefix}_abattement_total`] !== undefined) {
                                    allData.push({
                                        key: `${representantPrefix}_abattement_total`,
                                        name: "Abattement appliqué",
                                        value: Math.round(Number(currentOutput[`${representantPrefix}_abattement_total`] || 0)).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                                    });
                                }
                                if (currentOutput[`${representantPrefix}_abattement_restant`] !== undefined) {
                                    allData.push({
                                        key: `${representantPrefix}_abattement_restant`,
                                        name: "Abattement légal restant",
                                        value: Math.round(Number(currentOutput[`${representantPrefix}_abattement_restant`] || 0)).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                                    });
                                }
                                if (currentOutput[`${representantPrefix}_base_dmtg`] !== undefined) {
                                    allData.push({
                                        key: `${representantPrefix}_base_dmtg`,
                                        name: "Base Taxable",
                                        value: Math.round(Number(currentOutput[`${representantPrefix}_base_dmtg`] || 0)).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                                    });
                                }
                                if (currentOutput[`${representantPrefix}_tranche_initiale`] !== undefined && hasPositiveValue(currentOutput[`${representantPrefix}_tranche_initiale`])) {
                                    allData.push({
                                        key: `${representantPrefix}_tranche_initiale`,
                                        name: "Taux tranche initiale",
                                        value: parseInt(currentOutput[`${representantPrefix}_tranche_initiale`] * 100).toLocaleString("en-EN") + " %"
                                    });
                                }
                                if (currentOutput[`${representantPrefix}_tranche_finale`] !== undefined && hasPositiveValue(currentOutput[`${representantPrefix}_tranche_finale`])) {
                                    allData.push({
                                        key: `${representantPrefix}_tranche_finale`,
                                        name: "Taux tranche finale",
                                        value: parseInt(currentOutput[`${representantPrefix}_tranche_finale`] * 100).toLocaleString("en-EN") + " %"
                                    });
                                }
                                if (currentOutput[`${representantPrefix}_dmtg`] !== undefined) {
                                    allData.push({
                                        key: `${representantPrefix}_dmtg`,
                                        name: "Droits DMTG à payer",
                                        value: Math.round(Number(currentOutput[`${representantPrefix}_dmtg`] || 0)).toLocaleString('en-EN').replace(/,/g, ' ') + " €"
                                    });
                                }
                                if (currentOutput[`${representantPrefix}_article757b_abattement_total`] !== undefined) {
                                    allData.push({ key: `${representantPrefix}_article757b_abattement_total`, name: "Abattement appliqué", value: formatEuro(currentOutput[`${representantPrefix}_article757b_abattement_total`]) });
                                    allData.push({ key: `${representantPrefix}_article757b_base_dmtg`, name: "Base taxable", value: formatEuro(currentOutput[`${representantPrefix}_article757b_base_dmtg`]) });
                                    allData.push({ key: `${representantPrefix}_article757b_dmtg`, name: "Droits DMTG à payer", value: formatEuro(currentOutput[`${representantPrefix}_article757b_dmtg`]) });
                                }
                            });
                        }
                        allData = reorderDmtgResultLines(allData);
                        allDonataireData[i][j] = allData
                        //allDonateurData.push(allDonataireData)
                        //const base64Image = chartRef?.current?.chartInstance?.toBase64Image();

                    }
                }
                //console.log("donatairedata : " + JSON.stringify(allDonataireData))
                if (props?.callSinceSimu) {
                    localStorage.setItem("arrayContent", JSON.stringify(allDonataireData))
                    props.handleChange(props.setter, handleVar)
                } else {
                    if (allDonataireData.length > 0) {
                        localStorage.setItem("arrayContent", JSON.stringify(allDonataireData))
                        await setArrayContent(allDonataireData)
                        setCreatePDF(true)
                    }
                }
            }
        } else return data
    }


    async function calculate() {
        let currentData = data;

        if (typeof beforeCalculateDMTGRef.current === "function") {
            const conjointSurvivantResult = await beforeCalculateDMTGRef.current();
            if (conjointSurvivantResult === false) {
                return;
            }
            currentData = buildDataWithConjointSurvivant(data, conjointSurvivantResult);
        }

        if (!validateMainAmounts(currentData)) {
            return;
        }

        check(currentData).then(showModal)
    }

    useEffect(() => {
        //console.log("ARRAYCONTENT IS SET")
    }, [arrayContent])


    useEffect(() => {
        if (props.calculateDMTGState)
            calculate()
    }, [props.calculateDMTGState])

    function isNumeric(str) {
        if (typeof str != "string") return false
        return !isNaN(str) &&
            !isNaN(parseFloat(str))
    }

    function showModal() {
        setShow(true)
    }

    function hideModal() {
        setShow(false)
        setReadyPDF(false)
    }

    function getConjointSurvivantPdf() {
        try {
            return JSON.parse(localStorage.getItem("conjointSurvivantDMTG"));
        } catch (e) {
            return null;
        }
    }

    const formatEuro = (value) => parseInt(value || 0).toLocaleString('en-EN').replace(/,/g, ' ') + " €";

    const formatRate = (value) => parseInt(Number(value || 0) * 100).toLocaleString("en-EN") + " %";

    const formatPositive = (value) => formatEuro(Math.max(Number(value || 0), 0));

    const hasPositiveValue = (value) => Number(value || 0) > 0;

    const getDmtgPayload = (currentData) => currentData?.results || currentData;

    const getMainAmountWarning = (donataire) => {
        const simulateurId = Number(donataire?.simulateurid);

        if (simulateurId === 55) {
            return "Veuillez renseigner l'actif brut de succession.";
        }
        if (simulateurId === 56) {
            return "Veuillez renseigner le montant de la donation lui revenant ou le montant des espèces.";
        }
        if (simulateurId === 109) {
            return "Veuillez renseigner le montant de la donation lui revenant.";
        }
        if (simulateurId === 110) {
            return "Veuillez renseigner le montant de la donation lui revenant.";
        }
        return "Veuillez renseigner le montant principal.";

    };

    const hasValidMainAmount = (donataire) => {
        const simulateurId = Number(donataire?.simulateurid);
        const inputs = donataire?.inputs || {};

        if (simulateurId === 55) {
            return hasPositiveValue(inputs.montant_succession) || hasPositiveValue(props.montant_brut);
        }
        if (simulateurId === 56) {
            return hasPositiveValue(inputs.montant_donation) || hasPositiveValue(inputs.montant_especes);
        }
        if (simulateurId === 109) {
            return hasPositiveValue(inputs.montant_donation);
        }
        if (simulateurId === 110) {
            return hasPositiveValue(inputs.montant_especes);
        }
        return true;
    };

    const validateMainAmounts = (currentData) => {
        const payload = getDmtgPayload(currentData);
        const donataireWithMissingMainAmount = payload?.data
            ?.flatMap((donateur) => donateur?.donataires || [])
            ?.find((donataire) => !hasValidMainAmount(donataire));

        if (donataireWithMissingMainAmount) {
            enqueueSnackbar(getMainAmountWarning(donataireWithMissingMainAmount), {
                variant: "warning",
            });
            return false;
        }
        return true;
    };

    const reorderDmtgResultLines = (lines) => {
        const dmtgLines = lines.filter((line) => line.key === "DMTG");
        const visibleLines = lines.filter((line) => {
            if (line.key === "DMTG") return false;
            if (line.key === "tranche_initiale" || line.key === "tranche_finale") {
                return line.rawValue === undefined || hasPositiveValue(line.rawValue);
            }
            return true;
        });
        const isDonationResult = visibleLines.some((line) => line.key === "immo" || line.key === "especes");
        const donationPriorityKeys = [
            "immo",
            "especes",
            "abattement_reconstitue",
            "abattement_total",
            "abattement_restant",
            "base_dmtg",
            "tranche_initiale",
            "reliquat_tranche_donation",
            "tranche_finale",
        ];
        const successionPriorityKeys = [
            "handicap",
            "montant_revenant_heritier",
            "montant_rapportable",
            "montant_succession",
            "montant_article757b",
            "part_abattement_legal_restant",
            "abattement_reconstitue",
            "abattement_total",
            "abattement_restant",
            "base_dmtg",
        ];
        const priorityKeys = isDonationResult ? donationPriorityKeys : successionPriorityKeys;
        const priorityLines = priorityKeys
            .map((key) => visibleLines.find((line) => line.key === key))
            .filter(Boolean);
        const remainingLines = visibleLines.filter((line) => !priorityKeys.includes(line.key));

        return [...priorityLines, ...remainingLines, ...dmtgLines];
    };

    const renderResultLine = (name, value, options = {}) => (
        <div className={`dmtgResults${options.highlight ? " dmtgHighlight" : ""}`} key={options.key || name}>
            <tr>
                <td style={styles.td1}>{name}</td>
                <td style={styles.td2}>{value}</td>
            </tr>
        </div>
    );

    const getSuccessionSharingRows = () => {
        if (data?.data?.[0]?.donataires?.[0]?.simulateurid !== 55) return [];
        const rows = [];
        const firstDonateur = simulateurResponse?.data?.[0];
        firstDonateur?.donataires?.forEach((donataire, index) => {
            const represented = parseInt(donataire?.inputs?.est_represente || 0) === 1;
            const label = `${represented ? "Souche" : "Héritier"} ${index + 1}`;
            rows.push({
                key: `${label}-${index}`,
                name: label,
                represented,
                heirName: `Héritier ${index + 1}`,
                soucheName: `Souche ${index + 1}`,
                value: formatEuro(donataire?.inputs?.montantRevenantHeritier || donataire?.inputs?.montant_succession || 0),
            });
        });
        return rows;
    };

    const isSuccessionDmtg = () => data?.data?.[0]?.donataires?.[0]?.simulateurid === 55;

    const PersonIcon = ({ size = 18 }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2" />
            <path d="M4 20c0-4 4-6 8-6s8 2 8 6" stroke="currentColor" strokeWidth="2" />
        </svg>
    );

    const GroupIcon = ({ size = 18 }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="2" />
            <circle cx="16" cy="9" r="2.5" stroke="currentColor" strokeWidth="2" />
            <path d="M3 19c0-3 3-5 6-5s6 2 6 5" stroke="currentColor" strokeWidth="2" />
            <path d="M14 15c2.2 0 5 1.7 5 4.5" stroke="currentColor" strokeWidth="2" />
        </svg>
    );

    const SummaryIcon = () => (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect x="4" y="2" width="16" height="20" rx="2" stroke="currentColor" strokeWidth="1.8" />
            <line x1="7" y1="7" x2="17" y2="7" stroke="currentColor" strokeWidth="1.8" />
            <line x1="7" y1="11" x2="17" y2="11" stroke="currentColor" strokeWidth="1.8" />
            <line x1="7" y1="15" x2="13" y2="15" stroke="currentColor" strokeWidth="1.8" />
        </svg>
    );

    const renderModalField = (name, value, key, extraClassName = "") => (
        <div className={`dmtgDesignField${extraClassName ? ` ${extraClassName}` : ""}`} key={key || name}>
            <span className="dmtgDesignFieldLabel">{name}</span>
            <span className="dmtgDesignFieldValue">{value}</span>
        </div>
    );

    const renderModalOptionField = (item) => (
        <div className="dmtgDesignField dmtgDesignOptionField" key={item.key}>
            <span className="dmtgDesignFieldLabel">{item.name}</span>
            <div className="dmtgDesignOptionValueRow">
                <strong>{item.value}</strong>
                <span className="dmtgDesignFieldValue">{item.amount}</span>
            </div>
        </div>
    );

    const getResultValue = (items, key) => items?.find((item) => item.key === key)?.value;

    const renderConjointCard = (conjointSurvivantPdf) => {
        if (!conjointSurvivantPdf?.resultItems?.length) return null;
        const droitsConjoint = getResultValue(conjointSurvivantPdf.resultItems, "droits_cs") || "0 €";

        return (
            <div className="dmtgDesignCard dmtgDesignCardGreen" key="conjoint-survivant">
                    <div className="dmtgDesignCardHeader dmtgDesignCardHeaderGreen">
                    <span className="dmtgDesignIcon dmtgDesignIconGreen"><PersonIcon /></span>
                    <h3>CONJOINT SURVIVANT<span></span></h3>
                </div>
                <div className="dmtgDesignCardBody">
                    {renderModalField("Droits du conjoint survivant", droitsConjoint, "droits_cs")}
                    {renderModalField("DMTG à payer", "0 €", "conjoint_dmtg", "dmtgDesignDmtgText")}
                </div>
            </div>
        );
    };

    const renderRepresentantBlock = (representant, index, output, montantRepresentant) => {
        const representantIndex = representant.representant_index || index + 1;
        const representantPrefix = `representant_${representantIndex}`;

        return (
            <div className="dmtgDesignRepresentantBlock" key={representantPrefix}>
                <div className="dmtgDesignRepTag">Représentant {representantIndex}</div>
                <div className="dmtgDesignRepresentantBody">
                {parseInt(representant.handicap || 0) === 1 ? renderModalField("Situation de handicap", "Oui", `${representantPrefix}_handicap`) : null}
                {renderModalField("Montant lui revenant", formatEuro(montantRepresentant), `${representantPrefix}_montant_correspondant`)}
                {output[`${representantPrefix}_abattement_total`] !== undefined ? renderModalField("Abattement appliqué", formatEuro(Math.round(Number(output[`${representantPrefix}_abattement_total`] || 0))), `${representantPrefix}_abattement_total`) : null}
                {output[`${representantPrefix}_abattement_restant`] !== undefined ? renderModalField("Abattement légal restant", formatEuro(Math.round(Number(output[`${representantPrefix}_abattement_restant`] || 0))), `${representantPrefix}_abattement_restant`) : null}
                {output[`${representantPrefix}_base_dmtg`] !== undefined ? renderModalField("Base taxable", formatEuro(Math.round(Number(output[`${representantPrefix}_base_dmtg`] || 0))), `${representantPrefix}_base_dmtg`) : null}
                {hasPositiveValue(output[`${representantPrefix}_tranche_initiale`]) ? renderModalField("Taux tranche initiale", formatRate(output[`${representantPrefix}_tranche_initiale`]), `${representantPrefix}_tranche_initiale`) : null}
                {hasPositiveValue(output[`${representantPrefix}_tranche_finale`]) ? renderModalField("Taux tranche finale", formatRate(output[`${representantPrefix}_tranche_finale`]), `${representantPrefix}_tranche_finale`) : null}
                {renderModalField("DMTG à payer", formatEuro(Math.round(Number(output[`${representantPrefix}_dmtg`] || 0))), `${representantPrefix}_dmtg`, "dmtgDesignDmtgText")}
                {parseInt(representant.beneficiaire_assurance_vie || 0) === 1 ? (
                    <>
                        {renderModalField("Bénéficiaire assurance-vie", "Oui", `${representantPrefix}_beneficiaire_assurance_vie`)}
                        {renderModalField("Montant Article 757 B", formatPositive(representant.montant_taxable_article757b || 0), `${representantPrefix}_montant_article757b`)}
                        {output[`${representantPrefix}_article757b_abattement_total`] !== undefined ? renderModalField("Abattement appliqué", formatEuro(Math.round(Number(output[`${representantPrefix}_article757b_abattement_total`] || 0))), `${representantPrefix}_article757b_abattement_total`) : null}
                        {output[`${representantPrefix}_article757b_base_dmtg`] !== undefined ? renderModalField("Base taxable", formatEuro(Math.round(Number(output[`${representantPrefix}_article757b_base_dmtg`] || 0))), `${representantPrefix}_article757b_base_dmtg`) : null}
                        {output[`${representantPrefix}_article757b_dmtg`] !== undefined ? renderModalField("DMTG à payer", formatEuro(Math.round(Number(output[`${representantPrefix}_article757b_dmtg`] || 0))), `${representantPrefix}_article757b_dmtg`, "dmtgDesignDmtgText") : null}
                    </>
                ) : null}
                </div>
            </div>
        );
    };

    const renderHeritierCard = (donataire, i) => {
        const represented = parseInt(simulateurResponse?.data?.[0]?.donataires?.[i]?.inputs?.est_represente || 0) === 1;
        const title = represented ? `SOUCHE ${i + 1} (Héritier ${i + 1} ✝)` : `HÉRITIER ${i + 1}`;

        return (
            <div className="dmtgDesignCard dmtgDesignCardBlue" key={`heritier-${i}`}>
                <div className="dmtgDesignCardHeader dmtgDesignCardHeaderBlue">
                    <span className="dmtgDesignIcon dmtgDesignIconBlue">
                        {represented ? <GroupIcon /> : <PersonIcon />}
                    </span>
                    <h3>{title}</h3>
                </div>
                <div className="dmtgDesignCardBody">
                    {donataire.map((donateur, j) => {
                        const currentDonataire = simulateurResponse?.data?.[j]?.donataires?.[i];
                        const representants = Array.isArray(currentDonataire?.representants) ? currentDonataire.representants : [];
                        const output = currentDonataire?.output || {};
                        const nombreRepresentants = parseInt(currentDonataire?.inputs?.nombre_representants || representants.length || 0);
                        const montantRepresentant = nombreRepresentants > 0
                            ? Math.round(parseInt(currentDonataire?.inputs?.montant_succession || 0) / nombreRepresentants)
                            : 0;

                        if (represented && representants.length > 0) {
                            const soucheLineKeys = ["montant_revenant_heritier", "montant_rapportable", "montant_succession"];
                            const soucheLines = donateur.filter((value) => soucheLineKeys.includes(value.key));
                            return (
                                <React.Fragment key={`souche-${i}-donateur-${j}`}>
                                    {soucheLines.map((value) => renderModalField(value.name, value.value, value.key))}
                                    {representants.map((representant, index) => renderRepresentantBlock(representant, index, output, montantRepresentant))}
                                </React.Fragment>
                            );
                        }

                        const dmtgValue = getResultValue(donateur, "DMTG") || "0 €";
                        return (
                            <React.Fragment key={`heritier-${i}-donateur-${j}`}>
                                {donateur.filter((value) => value.key !== "DMTG").map((value) => renderModalField(value.name, value.value, value.key))}
                                {renderModalField("DMTG à payer", dmtgValue, "DMTG", "dmtgDesignDmtgText")}
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        );
    };

    const renderSuccessionDesign = (conjointSurvivantPdf) => {
        const synthesisItems = conjointSurvivantPdf?.synthesisItems || [];
        const hasSynthesis = synthesisItems.length > 0;
        const firstColumnKeys = ["actif_brut", "residence_principale", "autres_biens", "valeur_meubles", "passif_succession"];
        const firstColumn = synthesisItems.filter((item) => firstColumnKeys.includes(item.key));
        const secondColumn = synthesisItems.filter((item) => !firstColumnKeys.includes(item.key));
        const sharingRows = getSuccessionSharingRows();
        const droitsConjoint = getResultValue(conjointSurvivantPdf?.resultItems, "droits_cs");
        const cardsCount = (conjointSurvivantPdf?.resultItems?.length ? 1 : 0) + (arrayContent?.length || 0);
        const cardsClassName = `dmtgDesignCards${cardsCount >= 2 ? " dmtgDesignCardsThreeUp" : ""}`;

        return (
            <div className={`dmtgDesignContainer${hasSynthesis ? "" : " dmtgDesignContainerNoSynthesis"}`}>
                {hasSynthesis ? (
                        <div className="dmtgDesignSummaryCard">
                        <div className="dmtgDesignSummaryHeader">
                            <span className="dmtgDesignSummaryIcon"><SummaryIcon /></span>
                            SYNTHÈSE GLOBALE DE LA SUCCESSION
                        </div>
                        <div className="dmtgDesignSummaryBody">
                            <div className="dmtgDesignSummaryCol">
                                {firstColumn.map((item) => renderModalField(item.name, item.value, item.key))}
                            </div>
                            <div className="dmtgDesignSummaryCol">
                                {secondColumn.map((item) => (
                                    ["nouvelle_masse_a_partager", "masse_a_partager"].includes(item.key) ? (
                                        <div className="dmtgDesignField dmtgDesignAccentField" key={item.key}>
                                            <span className="dmtgDesignFieldLabel">{item.name}</span>
                                            <span className="dmtgDesignFieldValue">{item.value}</span>
                                        </div>
                                    ) : item.key === "droits_cs" && item.amount ? renderModalOptionField(item) : renderModalField(item.name, item.value, item.key)
                                ))}
                            </div>
                            <div className="dmtgDesignSummaryCol">
                                <div className="dmtgDesignRepartition">
                                    {droitsConjoint ? (
                                        <div className="dmtgDesignRepartitionRow dmtgDesignRepartitionRowNoBorder">
                                            <span className="dmtgDesignMiniIcon dmtgDesignMiniIconGreen"><PersonIcon size={14} /></span>
                                            <span>Conjoint survivant</span>
                                            <strong>{droitsConjoint}</strong>
                                        </div>
                                    ) : null}
                                    <p>RÉPARTITION DE LA MASSE À PARTAGER</p>
                                    {sharingRows.map((row, index) => (
                                        <div className="dmtgDesignRepartitionRow" key={row.key}>
                                            <span className="dmtgDesignMiniIcon dmtgDesignMiniIconBlue">
                                                {row.represented ? <GroupIcon size={14} /> : <PersonIcon size={14} />}
                                            </span>
                                            <span className={row.represented ? "dmtgDesignRepartitionNameStack" : ""}>
                                                {row.represented ? (
                                                    <>
                                                        <span>{row.soucheName}</span>
                                                        <span>({row.heirName} <span className="dmtgDesignDeathMark">✝</span>)</span>
                                                    </>
                                                ) : row.name}
                                            </span>
                                            <strong>{row.value}</strong>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                {hasSynthesis ? <div className="dmtgDesignConnector" /> : null}
                <div className={cardsClassName}>
                    {renderConjointCard(conjointSurvivantPdf)}
                    {arrayContent?.map((donataire, i) => renderHeritierCard(donataire, i))}
                </div>
            </div>
        );
    };

    const handleChange = (setter, value) => {
        setter(value)
    };


    function tablePrint() {


        if (arrayContent?.length > 0) {
            const conjointSurvivantPdf = getConjointSurvivantPdf();
            return (
                <div className={showHideClassName}>

                    <div className="modal-dmtg" >

                        <div className="modal-main-dmtg">
                            <>
                                {
                                    simulateurResponse !== undefined ?
                                        <div style={styles.ctnTable}>

                                            <div style={styles.ctnTableData}>
                                                <div style={{ flex: 6, boder: "1px solid grey" }}>
                                                    <p style={{
                                                        textAlign: "center",
                                                        fontSize: 20,
                                                    }}>Résultat de votre calcul de DMTG</p>


                                                    {
                                                        buttonPrint()
                                                    }

                                                    {isSuccessionDmtg() ? renderSuccessionDesign(conjointSurvivantPdf) : (
                                                        <div style={{
                                                            display: "flex",
                                                            flexFlow: "row wrap",
                                                            justifyContent: "center",
                                                            flexDirection: "column",
                                                            flexWrap: "nowrap",
                                                            alignItems: "center",
                                                        }}>

                                                        <table style={styles.table} >
                                                            <tbody style={styles.tableBody}>
                                                                {conjointSurvivantPdf?.resultItems?.length > 0 ? (
                                                                    <div className="blockConjointSurvivant">
                                                                        <div className="conjointSurvivantTitle">Conjoint survivant</div>
                                                                        <div className="blockHeritier2">
                                                                            {conjointSurvivantPdf.resultItems.map((value) => renderResultLine(value.name, value.value, { key: value.key, highlight: value.key === "droits_cs" }))}
                                                                        </div>
                                                                    </div>
                                                                ) : null}
                                                                {
                                                                    arrayContent ?
                                                                        arrayContent.map((donataire, i) => {
                                                                            if (data?.data[0].donataires[0].simulateurid === 55) {
                                                                                const represented = parseInt(simulateurResponse?.data?.[0]?.donataires?.[i]?.inputs?.est_represente || 0) === 1;
                                                                                return (<>
                                                                                    <div className="blockHeritier1">
                                                                                        <div className="heritierTitle">{represented ? "Souche" : "Héritier"} {i + 1} </div>
                                                                                        {donataire.map((donateur, j) => {
                                                                                            const currentDonataire = simulateurResponse?.data?.[j]?.donataires?.[i];
                                                                                            const representants = Array.isArray(currentDonataire?.representants) ? currentDonataire.representants : [];
                                                                                            const output = currentDonataire?.output || {};
                                                                                            const nombreRepresentants = parseInt(currentDonataire?.inputs?.nombre_representants || representants.length || 0);
                                                                                            const montantRepresentant = Math.round(parseInt(currentDonataire?.inputs?.montant_succession || 0) / nombreRepresentants);
                                                                                            return (<><div className="blockHeritier2">
                                                                                                {!represented ? donateur.map((value) => {
                                                                                                    var currentClass = {}
                                                                                                    if (value.key === "DMTG") {
                                                                                                        currentClass = {}
                                                                                                    }
                                                                                                    return (
                                                                                                        <>
                                                                                                            <div className={`dmtgResults${value.key === "DMTG" ? " dmtgHighlight" : ""}`}>
                                                                                                                <tr style={currentClass}>
                                                                                                                    <td style={styles.td1}>{value.name}</td>
                                                                                                                    <td style={styles.td2}>{value.value}</td>
                                                                                                                </tr>
                                                                                                            </div>
                                                                                                        </>
                                                                                                    )
                                                                                                }) : null}
                                                                                                {represented && representants.length > 0 ? (
                                                                                                    <>
                                                                                                        {representants.map((representant, index) => {
                                                                                                            const representantIndex = representant.representant_index || index + 1;
                                                                                                            const representantPrefix = `representant_${representantIndex}`;

                                                                                                            return (
                                                                                                            <React.Fragment key={index}>
                                                                                                                <div className="dmtgResults representantName">
                                                                                                                    <tr>
                                                                                                                        <td style={styles.td1}>Représentant {representantIndex}</td>
                                                                                                                        <td style={styles.td2}></td>
                                                                                                                    </tr>
                                                                                                                </div>
                                                                                                                {parseInt(representant.handicap || 0) === 1 ? (
                                                                                                                    renderResultLine("Situation de handicap", "Oui", { key: `${representantPrefix}_handicap` })
                                                                                                                ) : null}
                                                                                                                {renderResultLine("Montant lui revenant", formatEuro(montantRepresentant), { key: `${representantPrefix}_montant_correspondant` })}
                                                                                                                {parseInt(representant.beneficiaire_assurance_vie || 0) === 1 ? (
                                                                                                                    renderResultLine("Bénéficiaire assurance-vie", "Oui", { key: `${representantPrefix}_beneficiaire_assurance_vie` })
                                                                                                                ) : null}
                                                                                                                {parseInt(representant.beneficiaire_assurance_vie || 0) === 1 ? (
                                                                                                                    renderResultLine("Montant Article 757 B", formatPositive(output[`${representantPrefix}_montant_article757b`] ?? representant.montant_taxable_article757b ?? 0), { key: `${representantPrefix}_montant_article757b` })
                                                                                                                ) : null}
                                                                                                                {/*
                                                                                                                    À réactiver si la ligne doit de nouveau être affichée dans le cadre du représentant.
                                                                                                                    {parseInt(representant.beneficiaire_assurance_vie || 0) === 1 ? (
                                                                                                                        renderResultLine("Part restante de l'abattement légal du représentant", formatEuro(representant.part_abattement_legal_restant || 0), { key: `${representantPrefix}_part_abattement_legal_restant` })
                                                                                                                    ) : null}
                                                                                                                */}
                                                                                                                {output[`${representantPrefix}_abattement_total`] !== undefined ? (
                                                                                                                    renderResultLine("Abattement appliqué", formatEuro(Math.round(Number(output[`${representantPrefix}_abattement_total`] || 0))), { key: `${representantPrefix}_abattement_total` })
                                                                                                                ) : null}
                                                                                                                {output[`${representantPrefix}_abattement_restant`] !== undefined ? (
                                                                                                                    renderResultLine("Abattement légal restant", formatEuro(Math.round(Number(output[`${representantPrefix}_abattement_restant`] || 0))), { key: `${representantPrefix}_abattement_restant` })
                                                                                                                ) : null}
                                                                                                                {output[`${representantPrefix}_base_dmtg`] !== undefined ? (
                                                                                                                    renderResultLine("Base Taxable", formatEuro(Math.round(Number(output[`${representantPrefix}_base_dmtg`] || 0))), { key: `${representantPrefix}_base_dmtg` })
                                                                                                                ) : null}
                                                                                                                {hasPositiveValue(output[`${representantPrefix}_tranche_initiale`]) ? (
                                                                                                                    renderResultLine("Taux tranche initiale", formatRate(output[`${representantPrefix}_tranche_initiale`]), { key: `${representantPrefix}_tranche_initiale` })
                                                                                                                ) : null}
                                                                                                                {hasPositiveValue(output[`${representantPrefix}_tranche_finale`]) ? (
                                                                                                                    renderResultLine("Taux tranche finale", formatRate(output[`${representantPrefix}_tranche_finale`]), { key: `${representantPrefix}_tranche_finale` })
                                                                                                                ) : null}
                                                                                                                {output[`${representantPrefix}_dmtg`] !== undefined ? (
                                                                                                                    renderResultLine("Droits DMTG à payer", formatEuro(Math.round(Number(output[`${representantPrefix}_dmtg`] || 0))), { key: `${representantPrefix}_dmtg`, highlight: true })
                                                                                                                ) : null}
                                                                                                            </React.Fragment>
                                                                                                        )})}
                                                                                                    </>
                                                                                                ) : null}
                                                                                            </div>
                                                                                            </>)
                                                                                        })}
                                                                                    </div>
                                                                                </>)
                                                                            } else {
                                                                                return (<>
                                                                                    <div className="blockDonataire">
                                                                                        <div className="donataireTitle">Donataire {i + 1} </div>
                                                                                        {donataire.map((donateur, j) => {
                                                                                            return (<><div className="blockDonateur">
                                                                                                <div className="donateurTitle">Donateur {j + 1} </div>
                                                                                                {donateur.map((value) => {
                                                                                                    var currentClass = {}
                                                                                                    if (value.key === "DMTG") {
                                                                                                        currentClass = {}
                                                                                                    }
                                                                                                    return (
                                                                                                        <>
                                                                                                            <div className="dmtgResults">
                                                                                                                <tr style={currentClass}>
                                                                                                                    <td style={styles.td1}>{value.name}</td>
                                                                                                                    <td style={styles.td2}>{value.value}</td>
                                                                                                                </tr>
                                                                                                            </div>
                                                                                                        </>
                                                                                                    )
                                                                                                })}
                                                                                            </div>
                                                                                            </>)
                                                                                        })}
                                                                                    </div>
                                                                                </>)
                                                                            }
                                                                        })
                                                                        :
                                                                        <></>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    )}
                                                </div>



                                                <img src={`${close}`}
                                                    style={{
                                                        position: "absolute",
                                                        fontWeight: "bold",
                                                        right: 20,
                                                        height: 20,
                                                        cursor: "pointer"
                                                    }} onClick={e => {
                                                        hideModal()
                                                        setReadyPDF(false)
                                                    }} />
                                            </div>
                                        </div>
                                        :
                                        <div></div>
                                }
                            </>
                        </div>
                    </div>
                </div >
            )
        }
    }

    function buttonPrint() {
        return (
            <>
                <div style={{ ...styles.ctnButtonValide }}>
                    {createPDF === true ?
                        <div>
                            <LinkDMTGPDF simulateurObject={arrayContent}
                                ready={readyPDF}
                                setReadyMain={setReadyPDF} />
                        </div>
                        :
                        <></>
                    }
                </div>
            </>
        )
    }

    // useEffect(() => {
    //     tablePrint()
    // }, [arrayContent]);

    function printCalculateResult() {
        if (parserSimulator().props.children !== "Simulateur non disponible") {
            const useStyles = makeStyles({
                textarea: {
                    resize: "both"
                }
            });

            return (
                <>
                    <div
                        style={styles.ctnButton}>
                        <button
                            style={styles.buttonCalculate}
                            onClick={(e) => {
                                ReactGA.event({
                                    category: "Formulaire",
                                    action: "Clic bouton calculer DMTG",
                                    label: "calculer_dmtg"
                                });
                                calculate()
                            }}
                        >
                            Calculer les DMTG
                        </button>
                    </div>
                    {
                        tablePrint()
                    }
                </>
            )
        } else {
            return <></>
        }
    }

    function parserSimulator() {
        let check;
        if (props?.callSinceSimu) {
            check = props.simulateur.id.toString()
        } else {
            check = props.match.params.simulateur.toString()
        }

        switch (check) {
            // OK
            case "55": {
                return (
                    <>
                        <Simulateur_Successions
                            simulateur={parentSimulateur}
                            callSinceSimu={props.callSinceSimu}
                            montant_brut={props.montant_brut}
                            choix_meubles={props.choix_meubles}
                            valeur_meubles={props.valeur_meubles}
                            donations_rapportables={props.donations_rapportables}
                            onConjointSurvivantChange={props.onConjointSurvivantChange}
                            onCalculateConjointSurvivant={calculateConjointSurvivant}
                            registerBeforeCalculate={registerBeforeCalculate}
                        />
                    </>
                )
            }
            case "56": {
                return (
                    <>
                        <Simulateur_Donations
                            simulateur={parentSimulateur}
                            donateurs={props.donateurs}
                            callSinceSimu={props.callSinceSimu}
                        />
                    </>
                )
            }
            case "109": {
                return (
                    <>
                        <Simulateur_Donations
                            simulateur={parentSimulateur}
                            donateurs={props.donateurs}
                            callSinceSimu={props.callSinceSimu}
                        />
                    </>
                )
            }
            case "110": {
                return (
                    <>
                        <Simulateur_Donations
                            simulateur={parentSimulateur}
                            donateurs={props.donateurs}
                            callSinceSimu={props.callSinceSimu}
                        />
                    </>
                )
            }
            default: {
                return (
                    <h2>Simulateur non disponible</h2>
                )
            }
        }
    }

    // SWITCH WITH ID SIMULATEUR
    return (
        <div style={styles.container1}>
            { props?.callSinceSimu ? (
                <div style={styles.container}>
                    {parserSimulator()}
                </div>
            ) : (
                <>
                    <div style={styles.container}>
                        {parserSimulator()}
                        {printCalculateResult()}
                    </div>
                </>
            )}
        </div>
    )
}

export default DmtgMain;
